export default __webpack_public_path__ + "static/media/aboutimg.cfa1edff.svg";